import React from 'react';
import { Box, Skeleton } from '@mui/material';

function Level1DashboardSkeleton() {
  return (
    <Box sx={{ px: 0, py: 2 }}>
      {/* Header */}
      <Box sx={{
        display: 'flex', justifyContent: 'space-between', alignItems: 'center',
        mb: 3,
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
          <Skeleton variant="rounded" width={42} height={42} sx={{ borderRadius: 1.5 }} />
          <Box>
            <Skeleton variant="text" width={260} height={24} />
            <Skeleton variant="text" width={200} height={14} sx={{ mt: 0.5 }} />
            <Skeleton variant="text" width={100} height={12} sx={{ mt: 0.25 }} />
          </Box>
        </Box>
        <Skeleton variant="rounded" width={90} height={36} sx={{ borderRadius: '4px' }} />
      </Box>

      {/* Health Cards — 3 columns */}
      <Box sx={{
        display: 'grid',
        gridTemplateColumns: { xs: '1fr', sm: 'repeat(3, 1fr)' },
        gap: 2, mb: 2.5,
      }}>
        {[0, 1, 2].map(i => (
          <Box key={i} sx={{
            p: 2.5, border: '1px solid', borderColor: 'divider', borderRadius: 2.5,
            display: 'flex', flexDirection: 'column', gap: 1,
          }}>
            <Skeleton variant="text" width={80} height={14} />
            <Skeleton variant="text" width={i === 0 ? 100 : 50} height={32} />
            {i > 0 && (
              <>
                <Skeleton variant="rounded" width="100%" height={5} sx={{ borderRadius: 3 }} />
                <Skeleton variant="text" width={60} height={12} />
              </>
            )}
          </Box>
        ))}
      </Box>

      {/* Chart */}
      <Box sx={{
        border: '1px solid', borderColor: 'divider', borderRadius: 2.5,
        p: 2, mb: 2.5,
      }}>
        <Skeleton variant="text" width={140} height={20} sx={{ mb: 1.5 }} />
        <Skeleton variant="rounded" width="100%" height={280} sx={{ borderRadius: 1.5 }} />
      </Box>

      {/* Table */}
      <Box sx={{
        border: '1px solid', borderColor: 'divider', borderRadius: 2.5,
        overflow: 'hidden',
      }}>
        <Box sx={{ px: 2.5, py: 1.5, borderBottom: '1px solid', borderColor: 'divider' }}>
          <Skeleton variant="text" width={120} height={20} />
        </Box>
        {/* Header row */}
        <Box sx={{
          display: 'grid', gridTemplateColumns: 'repeat(11, 1fr)',
          gap: 1, px: 1.5, py: 1, borderBottom: '2px solid', borderColor: 'divider',
        }}>
          {Array.from({ length: 11 }).map((_, i) => (
            <Skeleton key={i} variant="text" height={14} />
          ))}
        </Box>
        {/* Body rows */}
        {Array.from({ length: 8 }).map((_, r) => (
          <Box key={r} sx={{
            display: 'grid', gridTemplateColumns: 'repeat(11, 1fr)',
            gap: 1, px: 1.5, py: 0.75, borderBottom: '1px solid', borderColor: 'divider',
          }}>
            {Array.from({ length: 11 }).map((_, c) => (
              <Skeleton key={c} variant="text" height={16} sx={{
                width: c === 0 ? '80%' : '60%',
              }} />
            ))}
          </Box>
        ))}
      </Box>
    </Box>
  );
}

export default Level1DashboardSkeleton;
